import React, { useMemo } from "react";
import PropTypes from "prop-types";

// Components
import { PreviewCardSlim } from "components/PreviewCardSlim/PreviewCardSlim";

// Hooks
import { useProfileResourcesPreviewCard } from "./hooks/useProfileResourcesPreviewCard";

// Platforms
import { Iterable } from "platforms/iterable/iterable";

// Utils
import { handleKeyDown } from "utils/eventUtils";

export const ProfileResourcesPreviewCard = ({
    isLoading = false,
    message = null,
    onOpenClaimLetterModal,
}) => {
    /**
     * Custom Hooks
     */

    const {
        brandMarkUrl,
        buttonStyle,
        cardStyle,
        elements,
        isClaimLetterAction,
        isSponsored,
        primaryButton,
    } = useProfileResourcesPreviewCard({ message });

    /**
     * useMemo
     */

    const defaultAction = useMemo(
        () => message?.elements?.defaultAction,
        [message?.elements?.defaultAction]
    );

    /**
     * End Hooks
     */

    const handleClick = () => {
        if (message) {
            Iterable.trackEmbeddedMessageClickEvent({ message });
        }

        if (isClaimLetterAction) {
            if (onOpenClaimLetterModal) {
                onOpenClaimLetterModal(message);
            }
        } else {
            if (
                primaryButton?.action?.data &&
                primaryButton?.action?.type === "openUrl"
            ) {
                window.open(primaryButton.action.data, "_blank");
                return;
            }
            if (defaultAction?.data && defaultAction?.type === "openUrl") {
                window.open(defaultAction.data, "_blank");
                return;
            }
        }
    };

    return (
        <PreviewCardSlim
            isLoading={isLoading}
            brandMarkUrl={brandMarkUrl}
            buttonStyle={buttonStyle}
            cardStyle={cardStyle}
            elements={elements}
            isSponsored={isSponsored}
            primaryButton={primaryButton}
            onClick={handleClick}
            onKeyDown={(e) => handleKeyDown(e, handleClick)}
        />
    );
};

ProfileResourcesPreviewCard.propTypes = {
    isLoading: PropTypes.bool,
    message: PropTypes.object,
    onOpenClaimLetterModal: PropTypes.func,
};
